enum ExamsRequestsFlowEnum {
	WAITING = 'WAITING',
	RELEASED = 'RELEASED',
}

export {ExamsRequestsFlowEnum};
